export default __webpack_public_path__ + "3a8c9db37e37fdffabdf9eeecc09a721.jpg";